export default {
  STORE_PATH: "auth",

  // CONSTS
  IS_LOADING: "IS_LOADING",
  CURRENT_USER: "CURRENT_USER",
  AUTH_INITIALIZED: "AUTH_INITIALIZED",

  // ACTIONS
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  GET_CURRENT_USER: "GET_CURRENT_USER",
  INITIALIZE_AUTH: "INITIALIZE_AUTH",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
}